import { useCallback, useRef, useState } from 'react'

interface DragStateIProps {
  x: number
  y: number
  scrollLeft: number
  scrollTop: number
}

export const useDragToPan = (enabled: boolean) => {
  const containerRef = useRef<HTMLDivElement | null>(null)
  const [isDragging, setIsDragging] = useState(false)
  const dragStartRef = useRef<DragStateIProps | null>(null)

  const handleMouseDown = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (!enabled || !containerRef.current) return

      setIsDragging(true)
      const container = containerRef.current

      dragStartRef.current = {
        x: e.clientX,
        y: e.clientY,
        scrollLeft: container.scrollLeft,
        scrollTop: container.scrollTop,
      }

      e.preventDefault()
    },
    [enabled]
  )

  const handleMouseMove = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (!isDragging || !containerRef.current || !dragStartRef.current) return

      const container = containerRef.current
      const { x, y, scrollLeft, scrollTop } = dragStartRef.current

      const dx = e.clientX - x
      const dy = e.clientY - y

      container.scrollLeft = scrollLeft - dx
      container.scrollTop = scrollTop - dy
    },
    [isDragging]
  )

  const handleMouseUp = useCallback(() => {
    setIsDragging(false)
    dragStartRef.current = null
  }, [])

  const handleMouseLeave = useCallback(() => {
    setIsDragging(false)
    dragStartRef.current = null
  }, [])

  return {
    containerRef,
    isDragging,
    handlers: {
      onMouseDown: handleMouseDown,
      onMouseMove: handleMouseMove,
      onMouseUp: handleMouseUp,
      onMouseLeave: handleMouseLeave,
    },
  }
}
